import React, { FunctionComponent } from 'react';

import withIconContainer from './withIconContainer';

const IconCardAmex: FunctionComponent = () => (
    <svg aria-labelledby="iconCardAmexTitle" height="104" role="img" viewBox="0 0 156 104" width="156" xmlns="http://www.w3.org/2000/svg">
        <title id="iconCardAmexTitle">Amex</title>
        <g fill="none" fillRule="evenodd">
            <path d="M144 104H12c-6.15 0-12-5.85-12-12V12C0 5.85 5.85 0 12 0h132c6.15 0 12 5.85 12 12v80c0 6.15-5.85 12-12 12z" fill="#60C7EE" />
            <g fill="#FFF">
                <path d="M95.05 46.532v3.68h12.93v4.723H95.05V59.5h12.79l5.244-6.824-4.673-6.144H95.05m-59.707 9.382h5.906l-2.97-8.324-2.94 8.324" />
                <path d="M128.833 52.77l11.29-15.125h-19.067l-2.536 3.9-2.608-3.9h-46.59l-1.254 4.224-1.264-4.227H31.27L17.72 68.687h17.326l1.31-3.822h3.824l1.345 3.822h73.594l3.28-4.594 3.28 4.594h19.36l-4.867-6.343-7.342-9.574zM83.185 64.744H76.38v-17.66l-5.243 17.66h-6.16l-5.233-17.66v17.66H44.318l-1.345-3.823H33.54l-1.312 3.826h-8.483L33.85 41.588h9.065L52.94 64.56V41.59h10.927l4.214 14.09 4.187-14.09h10.92v23.156zm40.524 0l-5.31-7.44-5.31 7.44H86.72V41.588h27.085l4.76 7.124 4.63-7.124h9.062l-8.37 11.215 9.16 11.94h-9.338z" />
            </g>
        </g>
    </svg>
);

export default withIconContainer(IconCardAmex);
